/*
 * EB Shipping Progress — barra de progreso de envío gratis + regalos.
 * Consume window.EBCart. Renderiza mensaje + barra según tier.
 * Tiers configurables vía data-* en la sección.
 */
(function () {
  if (!window.EBCart) {
    // eb-cart-state.js debe cargar antes
    document.addEventListener('eb-cart-state:ready', boot);
    return;
  }
  boot();

  function boot() {
    customElements.define('eb-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        this.thresholds = {
          t1: parseFloat(this.dataset.t1 || '35'),
          t2: parseFloat(this.dataset.t2 || '70'),
          t3: parseFloat(this.dataset.t3 || '100'),
        };
        this.giftsEnabled = (this.dataset.giftsEnabled || 'true') !== 'false';
        // T1 siempre activo cuando giftsEnabled. T2/T3 individualmente conmutables.
        this.tiersEnabled = {
          t1: true,
          t2: (this.dataset.t2Enabled || 'true') !== 'false',
          t3: (this.dataset.t3Enabled || 'true') !== 'false',
        };
        this.messages = {
          pre: this.dataset.msgPre || 'Mínimo de pedido {min}€ · te faltan {remaining}',
          t1: this.dataset.msgT1 || 'Envío gratis y unas muestras ✓ Faltan {remaining} para tu peine de regalo',
          t2: this.dataset.msgT2 || 'Envío gratis + peine ✓ Faltan {remaining} para el emulsionador',
          t3: this.dataset.msgT3 || 'Envío gratis + peine + emulsionador · gracias por confiar',
          // Mensajes para combinaciones cuando t2/t3 están desactivados
          t1NoMore: this.dataset.msgT1NoMore || 'Envío gratis y unas muestras ✓ Hecho artesanalmente en España',
          t1SkipT3: this.dataset.msgT1SkipT3 || 'Envío gratis y unas muestras ✓ Faltan {remaining} para tu emulsionador',
          t2DoneNoT3: this.dataset.msgT2DoneNoT3 || 'Envío gratis + peine ✓ Gracias por confiar',
          // Modo "solo envío gratis" (gifts_enabled=false): mensajes simples
          shippingPre: this.dataset.msgShippingPre || 'Envío GRATIS a partir de 35€ · te faltan {remaining}',
          shippingDone: this.dataset.msgShippingDone || 'Envío gratis ✓ Hecho artesanalmente en España',
          // Modo "pack activo" (cliente con pack-builder en cart): regalos no aplican
          packActive: this.dataset.msgPackActive || 'Pack personalizado activo · −10% aplicado · envío gratis ✓',
        };
        this.bar = this.querySelector('[data-eb-progress-bar]');
        this.text = this.querySelector('[data-eb-progress-text]');
        this.unsub = window.EBCart.subscribe((s) => this.render(s));
      }

      disconnectedCallback() {
        if (this.unsub) this.unsub();
      }

      formatMoney(amount) {
        const fmt = new Intl.NumberFormat('es-ES', {
          style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2
        });
        return fmt.format(amount);
      }

      computeTier(subtotal) {
        // Construye la secuencia de thresholds activos. Si t2 está OFF, salta
        // de t1 directo a t3 (o termina en t1 si t3 también está OFF).
        const en = this.tiersEnabled;
        const active = [];
        if (en.t1) active.push({ id: 't1', value: this.thresholds.t1 });
        if (en.t2) active.push({ id: 't2', value: this.thresholds.t2 });
        if (en.t3) active.push({ id: 't3', value: this.thresholds.t3 });

        for (let i = 0; i < active.length; i++) {
          if (subtotal < active[i].value) {
            const prevId = i === 0 ? 'pre' : active[i - 1].id;
            return { id: prevId, remaining: active[i].value - subtotal, next: active[i].value };
          }
        }
        const lastId = active.length > 0 ? active[active.length - 1].id : 'pre';
        return { id: lastId, remaining: 0, next: null };
      }

      pickMessage(tier) {
        // Elige el mensaje correcto teniendo en cuenta qué tiers están activos.
        // Casos especiales cuando t2 o t3 están OFF — el copy "para tu peine"
        // o "+ peine + emulsionador" no aplica si esos tiers no existen.
        const en = this.tiersEnabled;
        if (tier.id === 'pre') return this.messages.pre;

        if (tier.id === 't1') {
          // Estamos por encima de t1, esperando siguiente tier (o no hay más).
          if (en.t2) return this.messages.t1;          // Caso normal: siguiente es t2
          if (en.t3) return this.messages.t1SkipT3;    // Skip t2 → próximo es t3
          return this.messages.t1NoMore;               // No hay más tiers
        }

        if (tier.id === 't2') {
          // Estamos por encima de t2, esperando t3 (o no hay más).
          if (en.t3) return this.messages.t2;          // Caso normal
          return this.messages.t2DoneNoT3;             // t3 OFF → estamos al tope
        }

        // tier.id === 't3' → todo cleared
        return this.messages.t3;
      }

      hasActivePack(items) {
        const counts = {};
        for (const it of items || []) {
          const grp = it.properties && it.properties._pack_grupo;
          if (!grp) continue;
          counts[grp] = (counts[grp] || 0) + 1;
        }
        for (const k in counts) {
          if (counts[k] >= 4) return true;
        }
        return false;
      }

      render(state) {
        if (!state || !state.hydrated) return;
        // Real (non-gift) subtotal: gifts have _es_regalo line property and shouldn't count toward progress
        const items = state.items || [];
        let subtotal = 0;
        for (const it of items) {
          const isGift = it.properties && it.properties._es_regalo;
          if (isGift) continue;
          subtotal += (it.original_line_price ?? it.line_price ?? 0);
        }
        subtotal = subtotal / 100;
        const packActive = this.hasActivePack(items);

        // Decide qué progresión y qué texto mostrar.
        // Modo A: gifts_enabled=false → solo barra de envío gratis (escala 0–t1)
        // Modo B: gifts_enabled=true + pack en cart → mensaje pack, barra al 100%
        // Modo C: gifts_enabled=true + sin pack → comportamiento normal de regalos
        const en = this.tiersEnabled;
        let pct, textTpl, dataTier, scaleMax;
        if (!this.giftsEnabled) {
          // Modo A: solo envío gratis
          scaleMax = this.thresholds.t1;
          pct = Math.max(2, Math.min(100, (subtotal / scaleMax) * 100));
          if (subtotal >= this.thresholds.t1) {
            textTpl = this.messages.shippingDone;
            dataTier = 't1';
          } else {
            textTpl = this.messages.shippingPre;
            dataTier = 'pre';
          }
        } else if (packActive) {
          // Modo B: pack en el cart, regalos no acumulables
          scaleMax = en.t3 ? this.thresholds.t3 : (en.t2 ? this.thresholds.t2 : this.thresholds.t1);
          pct = 100;
          textTpl = this.messages.packActive;
          dataTier = 'pack';
        } else {
          // Modo C: regalos progresivos. scaleMax = el threshold del último tier
          // activo, para que la barra acabe siempre al 100% en el tier más alto.
          if (en.t3) scaleMax = this.thresholds.t3;
          else if (en.t2) scaleMax = this.thresholds.t2;
          else scaleMax = this.thresholds.t1;
          pct = Math.max(2, Math.min(100, (subtotal / scaleMax) * 100));
          const tier = this.computeTier(subtotal);
          textTpl = this.pickMessage(tier);
          dataTier = tier.id;
        }

        if (this.bar) {
          this.bar.style.setProperty('--eb-progress-pct', `${pct}%`);
          // Variables que el CSS usa para reposicionar los pips según el scaleMax dinámico.
          this.bar.style.setProperty('--eb-t1', String(this.thresholds.t1));
          this.bar.style.setProperty('--eb-t2', String(this.thresholds.t2));
          this.bar.style.setProperty('--eb-progress-scale', String(scaleMax));
          this.bar.setAttribute('aria-valuemax', String(Math.round(scaleMax)));
          this.bar.setAttribute('aria-valuenow', String(Math.round(subtotal)));
        }

        const remainingT1 = Math.max(0, this.thresholds.t1 - subtotal);
        const tierForReplace = this.computeTier(subtotal);
        const replaced = textTpl
          .replace('{min}', String(this.thresholds.t1))
          .replace(/\{remaining\}/g, this.formatMoney(this.giftsEnabled && !packActive ? tierForReplace.remaining : remainingT1))
          .replace('{next}', this.formatMoney(tierForReplace.next || 0))
          .replace('{subtotal}', this.formatMoney(subtotal));

        if (this.text) this.text.textContent = replaced;
        this.dataset.tier = dataTier;
      }
    });
  }
})();
